import { pickAccountIdentifier } from './pickAccountIdentifier';
import type { ContractPrincipal, PrincipalInput } from './types';

/**
 * Extracts a {@link ContractPrincipal} from a {@link PrincipalInput}.
 * For users, picks `accountUuid` (flag on) or `accountId` (flag off).
 * Throws if no identifier is present.
 */
function extractPrincipal(input: PrincipalInput, useUuid: boolean): ContractPrincipal {
  const { accountId, accountUuid, groupId, organizationId } = input;

  if (accountId != null || accountUuid != null) {
    const principalId = pickAccountIdentifier(input, 'accountId', useUuid);
    if (principalId == null) throw new Error('No principal id could be extracted for the user');
    return { principalType: 'user', principalId };
  }

  if (groupId != null) return { principalType: 'group', principalId: groupId };
  if (organizationId != null) return { principalType: 'organization', principalId: organizationId };

  throw new Error('No principal could be extracted');
}

export { extractPrincipal };
